import httpServices from './httpServices'

async function createGroup(name, type, currency = 'ILS') {
    const response = await httpServices.post('/groups', { name, type, currency })
    return response.data
}

async function getCurrencies() {
    const response = await httpServices.get('/groups/currencies')
    return response.data
}

async function getExchangeRate(from, to, amount = 1) {
    const response = await httpServices.get(`/groups/exchange-rate?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}&amount=${amount}`)
    return response.data
}

async function getMyGroups() {
    const response = await httpServices.get('/groups/my')
    return response.data
}

// Archived groups are excluded from getMyGroups by default (see backend) —
// this is the quiet "view finished trips" list behind the group switcher.
async function getArchivedGroups() {
    const response = await httpServices.get('/groups/my?archived=1')
    return response.data
}

async function archiveGroup(groupId) {
    const response = await httpServices.post(`/groups/${groupId}/archive`)
    return response.data
}

async function unarchiveGroup(groupId) {
    const response = await httpServices.post(`/groups/${groupId}/unarchive`)
    return response.data
}

async function getGroup(groupId) {
    const response = await httpServices.get(`/groups/${groupId}`)
    return response.data
}

async function updateGroup(groupId, data) {
    const response = await httpServices.put(`/groups/${groupId}`, data)
    return response.data
}

async function getBalances(groupId) {
    const response = await httpServices.get(`/groups/${groupId}/balances`)
    return response.data
}

async function getBudget(groupId) {
    const response = await httpServices.get(`/groups/${groupId}/budget`)
    return response.data
}

async function putBudget(groupId, data) {
    const response = await httpServices.put(`/groups/${groupId}/budget`, data)
    return response.data
}

async function getSummary(groupId, month) {
    const response = await httpServices.get(`/groups/${groupId}/summary${month ? `?month=${month}` : ''}`)
    return response.data
}

async function getInviteCode(groupId) {
    const response = await httpServices.post(`/groups/${groupId}/invite-code`)
    return response.data
}

async function joinByCode(code) {
    const response = await httpServices.post('/groups/join', { code })
    return response.data
}

async function claimPlaceholder(groupId, placeholderId) {
    const response = await httpServices.post(`/groups/${groupId}/claim-placeholder`, { placeholderId })
    return response.data
}

async function leaveGroup(groupId) {
    const response = await httpServices.post(`/groups/${groupId}/leave`)
    return response.data
}

async function removeMember(groupId, userId) {
    const response = await httpServices.delete(`/groups/${groupId}/members/${userId}`)
    return response.data
}

async function getRecurring(groupId) {
    const response = await httpServices.get(`/groups/${groupId}/recurring`)
    return response.data
}

async function createRecurring(groupId, data) {
    const response = await httpServices.post(`/groups/${groupId}/recurring`, data)
    return response.data
}

async function updateRecurring(groupId, recurringId, data) {
    const response = await httpServices.put(`/groups/${groupId}/recurring/${recurringId}`, data)
    return response.data
}

async function deleteRecurring(groupId, recurringId) {
    const response = await httpServices.delete(`/groups/${groupId}/recurring/${recurringId}`)
    return response.data
}

export default {
    createGroup,
    getCurrencies,
    getExchangeRate,
    getMyGroups,
    getArchivedGroups,
    archiveGroup,
    unarchiveGroup,
    getGroup,
    updateGroup,
    getBalances,
    getBudget,
    putBudget,
    getSummary,
    getInviteCode,
    joinByCode,
    claimPlaceholder,
    leaveGroup,
    removeMember,
    getRecurring,
    createRecurring,
    updateRecurring,
    deleteRecurring,
}
